import React, { useState, useMemo } from "react";
import { useRouter } from "next/router";
import Link from "@/utils/link";
import Image from "next/legacy/image";

import { getMDXComponent } from "mdx-bundler/client";

import { imageLoader, removeExt } from "@/utils/image";
import CpSignUp from "./CpSignUp";

const CustomLink = (props) => {
    const href = props.href;
    const isInternalLink = href && (href.startsWith("/") || href.startsWith("#"));

    if (isInternalLink) {
        return (
            <Link href={href}>
                <a {...props}>{props.children}</a>
            </Link>
        );
    }

    return <a target="_blank" rel="noopener noreferrer" {...props} />;
};

const CustomImage = ({ src, alt, ...props }) => {
    let newSrc = src;

    if (newSrc.startsWith("https://cdn.purpledoorfinders.com/")) {
        newSrc = removeExt(newSrc);
        //newSrc = newSrc + ".md.jpg";
        newSrc = newSrc + ".sm.jpg";
    }

    return <img src={newSrc} alt={alt} {...props} />;
};

const MDXComponents = {
    Image,
    a: CustomLink,
    img: CustomImage,
};

export const LinkItem = ({ link, label, path }) => {
    return (
        <div
            className={
                "px-2 py-1 text-primary-500 uppercase hover:bg-primary-100 hover:rounded" +
                (path === link ? " border-b-2 border-primary-500" : "")
            }
        >
            <Link href={link}>{label}</Link>
        </div>
    );
};

const CpHero = ({ companyMarkdownCode }) => {
    const router = useRouter();

    const path = router.pathname;

    return (
        <div className="relative">
            <div className="sm:container mx-auto px-8 sm:px-16 flex">
                <div className="w-full sm:w-1/2 pt-8 pr-0 sm:min-h-[540px] max-w-lg">
                    <h2 className="text-gray-sec text-xl font-bold tracking-normal font-headline uppercase">
                        For Communities
                    </h2>

                    <h1 className="mt-2 text-primary-500 text-2xl font-bold tracking-normal font-headline">
                        Be Discoverable!
                    </h1>

                    <p className="mt-4 text-base">
                        Seniors, families, and caseworkers are actively searching for
                        vacancies on our website. Many are working with a senior who is
                        experiencing a change in condition, in crisis, or preparing for a
                        hospital discharge. Be discoverable with our Membership Listing. Win
                        tours with our direct tour booking feature. More importantly, let
                        them know when your community has a vacancy. It takes less than 5
                        minutes to claim or add your community. Once you're live, sit back,
                        and our team will reach out to help optimize your listing with our
                        AI profile builder.
                    </p>

                    {/*<ul className="mt-4 ml-6 text-base list-disc">
                        <li>Sign up and verify your email</li>
                        <li>
                            Go through our Setup Wizard to complete your listing in 5
                            minutes
                        </li>
                        <li>Add floorplans & photos</li>
                        <li>Approve your listing</li>
                    </ul>*/}

                    {/*<p className="my-4 sm:my-0 sm:hidden text-xl font-bold">
                        Note: To sign up and manage communities - open on desktop computer
                        or tablet
                    </p>*/}
                </div>

                <div className="hidden sm:block sm:w-1/2 pl-16 sm:mt-4 xl:mt-8 2xl:mt-8">
                    <h2 className="text-gray-sec text-xl font-bold tracking-normal font-headline uppercase">
                        Community Membership
                    </h2>

                    <h1 className="mt-2 text-primary-500 text-2xl font-bold tracking-normal font-headline">
                        Join Our Membership!
                    </h1>

                    <p className="mt-4 text-base">
                        Purple Door has a better way for communities to manage their
                        marketing budget and increase occupancy. Here’s how it works: when a
                        resident lead takes financial possession for a move-in, the
                        community pays our annual Membership Listing fee. All other move-ins
                        in that year are included in the membership Listing fee. The
                        Membership Listing fee will automatically renew annually at the
                        current posted rate. To become a member of the Purple Door
                        marketplace, simply claim or add your communities and agree to our
                        Terms of Use.
                    </p>

                    <div className="mt-8 flex justify-center">
                        <CpSignUp />
                    </div>
                </div>
            </div>

            <div className="sm:hidden w-full mx-auto px-8 my-6">
                <h2 className="text-gray-sec text-xl font-bold tracking-normal font-headline uppercase">
                    Community Membership
                </h2>

                <h1 className="mt-2 text-primary-500 text-2xl font-bold tracking-normal font-headline">
                    Join Our Membership!
                </h1>

                <p className="my-4 text-base">
                    Purple Door has a better way for communities to manage their marketing
                    budget and increase occupancy. Here’s how it works: when a resident lead
                    takes financial possession for a move-in, the community pays our annual
                    Membership Listing fee. All other move-ins in that year are included in
                    the membership Listing fee. The Membership Listing fee will
                    automatically renew annually at the current posted rate. To become a
                    member of the Purple Door marketplace, simply claim or add your
                    communities and agree to our Terms of Use.
                </p>

                <CpSignUp />
            </div>

            {/*<div className="-z-20 sm:hidden absolute top-0 left-0 right-0 bottom-0 h-64 bg-black"></div>*/}

            {/*companyMarkdownCode ? (
                <div className="absolute top-0 left-0 sm:left-1/2 right-0 bottom-0">
                    <div style={{ maxHeight: 600 }} className="overflow-hidden">
                        <CompanyMarkdown companyMarkdownCode={companyMarkdownCode} />
                    </div>
                </div>
            ) : (
                <div className="absolute top-0 left-0 sm:left-1/2 right-0 bottom-0 h-64 sm:h-full">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/community-portal-hero"
                        alt="community-portal-hero"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                        priority
                        unoptimized={false}
                        className="-z-10 opacity-75 sm:opacity-100"
                    />
                </div>
            )*/}
        </div>
    );
};

/*const CompanyMarkdown = ({ companyMarkdownCode }) => {
    const Component = useMemo(
        () => getMDXComponent(companyMarkdownCode),
        [companyMarkdownCode]
    );

    return (
        <div>
            <Component components={MDXComponents} />
        </div>
    );
};*/

export default CpHero;
